import React, {Component} from 'react';
import {Container, Header, Icon, Loader} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../utils/localization";
import {connect} from "react-redux";
import Footer from "./footer";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, getStepProps, isAIG, isAnsel, isRenaissance} from "../utils/common";
import CoveredModal from "./coveredModal";
import {setPrevRoute} from "../actions/appHeaderActions";
import Steps from "./steps/steps";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import {ClickableText, CustomDivider, CustomGrid} from "./custom-common";
import AdditionalRidersRows from "./additionalRidersRows";

const mapStateToProps = (state, ownProps) => {
    const { user, benAdmin, initialData } = state;

    return {
        lang: user?.lang,
        initialData,
        user,
        benAdmin,
        ...ownProps,
    };
};

class AlsoIncludes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            displayCoveredModal: false,
        };
    }

    componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        this.buildSteps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    doDisplayCoveredModal = (status) => {
        this.setState({
            displayCoveredModal: status
        });
    }

    renderFullListOfConditionsModal = (localization) => {
        const {displayCoveredModal} = this.state;
        return <CoveredModal localization={localization}
                             displayCoveredModal={displayCoveredModal}
                             onModalClose={() => this.doDisplayCoveredModal(false)}
        />;
    }

    render() {
        const {stepProps} = this.state;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const { lang } = this.props;
        const localization = getLocalization(lang);
        const strings = localization.yourBrellaPlanAlsoIncludes;

        return (
            <React.Fragment>
                <Container>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    {this.renderFullListOfConditionsModal(localization)}
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid className={'alsoIncludesContentGrid'}>
                                <CustomGrid.Row>
                                    <Header as={'h2'}>
                                        {isAIG() || isRenaissance() ? strings.title : <>{STRATEGIC_PARTNER.LABEL}<span className={'plusSignColor'}>+</span></>}
                                    </Header>
                                </CustomGrid.Row>
                                <CustomGrid.Row fitted={'vertically'}>{strings.yourBrellaPlan}{isRenaissance() && lang === 'es' ? ':' : !isRenaissance() && strings.payoutListed}</CustomGrid.Row>
                                <CustomDivider hidden />
                                <AdditionalRidersRows />
                                <CustomGrid.Row fitted>
                                <CustomGrid.Column>
                                        <ClickableText onClick={() => this.doDisplayCoveredModal(true)}>
                                            {strings.seeFullList}<Icon name="long arrow alternate right"/></ClickableText>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>
                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                    pauseAutoAdvance={this.state.displayCoveredModal}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(AlsoIncludes));